import { useState, useEffect } from "react";
import { TableEditItem } from "./TableEditItem";
import { TablePreviewItem } from "./TablePreviewItem";
import { EditAction, DeleteAction, SaveAction, AbortAction } from "./TableActions";
import { ActionCell } from "./Cells/ActionCell";
import { TableRow } from "./TableRow";
import { selectAddNewState } from "../../store/slices/dataTablesSlice";
import { useDispatch, useSelector } from "react-redux";

export function TableItem({ columns, itemdata, isnew = false, functions }) {
  const iData = { ...itemdata };
  const [formState, setFormState] = useState(structuredClone(iData));
  const id = itemdata?._id;
  const [isEditActive, setIsEditActive] = useState(false);
  const [isNew, setIsNew] = useState(isnew);
  const isInAddNewState = useSelector(selectAddNewState);

  useEffect(() => {}, [isEditActive, isNew, formState]);
  return (
    <>
      {!isEditActive && !isNew && (
        <TableRow>
          <>
            <TablePreviewItem columns={columns} values={formState} />
            <ActionCell>
              <EditAction
                tableItem={formState}
                handleAction={() => {
                  setIsEditActive(true);
                }}
              />
              {functions.delete && (
                <DeleteAction
                  tableItem={formState}
                  item={itemdata?._id ?? -1}
                  handleAction={() => {
                    functions.delete(id);
                  }}
                />
              )}
            </ActionCell>
          </>
        </TableRow>
      )}

      {isEditActive && (
        <TableRow>
          <>
            <TableEditItem
              columns={columns}
              values={formState}
              //isnew={true}
              functions={{
                handleSave: (e) => {
                  setFormState(e);
                },
              }}
            />
            <ActionCell>
              <SaveAction
                tableItem={formState}
                handleAction={() => {
                  functions?.update(formState);
                  setIsEditActive(false);
                }}
              />
              <AbortAction
                handleAction={() => {
                  setFormState(itemdata);
                  setIsEditActive(false);
                  setIsNew(false);
                  functions?.abort();
                }}
              />
            </ActionCell>
          </>
        </TableRow>
      )}

      {isInAddNewState && (
        <TableRow>
          <>
            <TableEditItem
              columns={columns}
              values={formState}
              functions={{
                handleSave: (e) => {
                  setFormState(e);
                },
              }}
            />
            <ActionCell>
              <SaveAction
                tableItem={formState}
                handleAction={() => {
                  functions?.addNew(formState);
                }}
              />
              <AbortAction
                handleAction={() => {
                  setIsEditActive(false);
                  functions?.abort();
                }}
              />
            </ActionCell>
          </>
        </TableRow>
      )}
    </>
  );
}
